import { ComponentProps } from 'react';
import { isIntegerSchema } from '../types';
import { IntegerInputField } from './IntegerInputField';
import { NumberInputField } from './NumberInputField/NumberInputField';

type MoneyInputFieldProps =
  | ComponentProps<typeof IntegerInputField>
  | ComponentProps<typeof NumberInputField>;

export const MoneyInputField = (props: MoneyInputFieldProps) => {
  if (isIntegerSchema(props.schema)) {
    return (
      <IntegerInputField
        {...(props as ComponentProps<typeof IntegerInputField>)}
        suffix="kr"
        suffixAriaLabel="Norske kroner"
      />
    );
  }
  return (
    <NumberInputField
      {...(props as ComponentProps<typeof NumberInputField>)}
      integerLabel="Kroner"
      decimalLabel="Øre"
    />
  );
};
